import React from 'react';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import BasicFormWithValidation from '../../../../forms/BasicFormWithValidation';
import {FormWithCancelButton} from '../../../../forms/FormWithCancelButton';
import gitHubIcon from '../../../../../assets/images/github/github-black.svg';

class CommitScriptChangesToGitHubForm extends FormWithCancelButton {

    validateCommitMessage = ({ message }) => {
        if (!message) {
            return 'Enter commit massage';
        }
        return null;
    }

    ok = ({ message }) => {
        const { pushProjectToGithub, onClose, project } = this.props;
        onClose();
        pushProjectToGithub({ project, message });
    }

    render() {
        return <BasicFormWithValidation
            title="Commit & push changes to GitHub"
            titleIconImg={gitHubIcon}
            hasCloseIcon={true}
            inputs={[{
                name: 'message',
                label: 'Commit massage',
                autoFocus: true,
                value: '',
                rules: [this.validateCommitMessage],
                applyOnEnter: true
            }]}
            okButton={{
                label: 'Commit & push',
                action: this.ok
            }}
            cancelButton={{
                label: 'Cancel',
                action: this.cancel,
            }}
        />;
    }
}

export default withClickOutsideOnOverlay(CommitScriptChangesToGitHubForm);